var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collection-grid__container" },
    [
      _c("side-drawer-shop-the-look", {
        staticClass: "shop-the-look__wrapper",
        attrs: { "shop-the-look-tile": _vm.shopTheLookTile }
      }),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "collection-grid__layout" },
          [
            _vm.notMobileTablet &&
            _vm.visibilitySettings.sidebarDisabled !== true
              ? _c("collection-sidebar", {
                  attrs: {
                    "default-sort": _vm.defaultSort,
                    "global-menu": _vm.globalMenu,
                    "collection-menu": _vm.collectionMenu,
                    "filters-disabled": _vm.visibilitySettings.filtersDisabled,
                    tags: _vm.tags,
                    filters: _vm.filters,
                    relatedCollections: _vm.relatedCollections
                  }
                })
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "collection-grid__wrapper",
                class: [
                  _vm.visibilitySettings.sidebarDisabled === true
                    ? "collection-grid__wrapper--no-sidebar"
                    : "collection-grid__wrapper--sidebar"
                ]
              },
              [
                _c("collection-grid-header", {
                  attrs: {
                    "pagination-amount": _vm.paginationAmount,
                    "total-pages": _vm.totalPages,
                    tags: _vm.tags,
                    filters: _vm.filters,
                    "default-sort": _vm.defaultSort,
                    filtersDisabled: _vm.visibilitySettings.filtersDisabled,
                    "collection-menu-title": _vm.collectionMenuTitle,
                    "global-menu": _vm.globalMenu,
                    "collection-menu": _vm.collectionMenu,
                    "hero-settings": _vm.heroSettings
                  }
                }),
                _c("collection-active-filters"),
                _c(
                  "fade-transition",
                  { attrs: { duration: { enter: 800, leave: 200 } } },
                  [
                    (!this.fetchingStatus.coverAll ||
                      !this.fetchingStatus.status) &&
                    this.currentTotal >= 1 &&
                    (this.promoTile.enabled === 1 ||
                      this.shopTheLookTile.enabled === 1)
                      ? _c(
                          "div",
                          { key: "grid", staticClass: "collection-grid" },
                          [
                            _vm.promoTile.enabled === 1 &&
                            _vm.shopTheLookTile.enabled === 0 &&
                            _vm.currentProducts.length >= 6
                              ? _c("collection-promo-tile", {
                                  staticClass: "is-shop-the-look-tile",
                                  style:
                                    _vm.$mq === "desktop" || _vm.$mq === "hd"
                                      ? _vm.gridPositionAndSpanDesktopPromo
                                      : _vm.gridPositionAndSpanMobilePromo,
                                  attrs: { "promo-tile": _vm.promoTile }
                                })
                              : _vm._e(),
                            _vm.shopTheLookTile.enabled === 1 &&
                            _vm.currentProducts.length >= 6
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "collection-shop-the-look-tile__wrapper is-shop-the-look-tile",
                                    style:
                                      _vm.$mq === "desktop" || _vm.$mq === "hd"
                                        ? _vm.gridPositionAndSpanDesktopShopTheLook
                                        : _vm.gridPositionAndSpanMobileShopTheLook,
                                    on: { click: _vm.openShopTheLook }
                                  },
                                  [
                                    _c("collection-shop-the-look-tile", {
                                      attrs: {
                                        "shop-the-look-tile":
                                          _vm.shopTheLookTile
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._l(_vm.currentProducts, function(
                              product,
                              index
                            ) {
                              return _c(
                                "div",
                                { staticClass: "collection-grid-item" },
                                [
                                  !product.position
                                    ? _c("product-tile", {
                                        key: product.id,
                                        style: "order: " + index,
                                        attrs: {
                                          "selected-variant": !product.position
                                            ? _vm.getCurrentFilteredVariant(
                                                product
                                              )
                                            : null,
                                          "show-mobile-ATC": true,
                                          "collection-handle":
                                            _vm.currentCollectionHandle,
                                          product: product,
                                          onAddToCart: _vm.addToCart,
                                          "global-logo-badge": !_vm.disableLogoBadge
                                            ? _vm.globalLogoBadge
                                            : undefined,
                                          "collection-template":
                                            _vm.collectionTemplate,
                                          "hide-badges":
                                            _vm.visibilitySettings
                                              .badgesDisabled,
                                          "on-click-product":
                                            _vm.onClickProduct,
                                          "promo-text": _vm.promoText,
                                          "promo-text-color": _vm.promoTextColor
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                ),
                _c(
                  "fade-transition",
                  { attrs: { duration: { enter: 800, leave: 200 } } },
                  [
                    (!this.fetchingStatus.coverAll ||
                      !this.fetchingStatus.status) &&
                    this.currentTotal >= 1 &&
                    (!this.promoTile.enabled || this.promoTile.enabled === 0) &&
                      (!this.shopTheLookTile.enabled ||
                        this.shopTheLookTile.enabled === 0)
                      ? _c(
                          "div",
                          {
                            key: "grid",
                            staticClass: "collection-grid no-promo-tile"
                          },
                          _vm._l(_vm.currentProducts, function(product, index) {
                            return _c(
                              "div",
                              { staticClass: "collection-grid-item" },
                              [
                                _c("product-tile", {
                                  key: product.id,
                                  style: "order: " + index,
                                  attrs: {
                                    "selected-variant": _vm.getCurrentFilteredVariant(
                                      product
                                    ),
                                    "show-mobile-ATC": true,
                                    "collection-handle":
                                      _vm.currentCollectionHandle,
                                    product: product,
                                    onAddToCart: _vm.addToCart,
                                    "global-logo-badge": !_vm.disableLogoBadge
                                      ? _vm.globalLogoBadge
                                      : undefined,
                                    "collection-template":
                                      _vm.collectionTemplate,
                                    "hide-badges":
                                      _vm.visibilitySettings.badgesDisabled,
                                    "on-click-product": _vm.onClickProduct,
                                    "promo-text": _vm.promoText,
                                    "promo-text-color": _vm.promoTextColor
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                ),
                _c(
                  "fade-transition",
                  { attrs: { duration: { enter: 600, leave: 200 } } },
                  [
                    this.fetchingStatus.status
                      ? _c(
                          "div",
                          {
                            key: "skeleton",
                            staticClass:
                              "collection-grid collection-grid__skeleton"
                          },
                          _vm._l(_vm.paginationAmount, function(n) {
                            return _c(
                              "div",
                              {
                                key: "skel-" + n,
                                staticClass: "collection-grid__skeleton-tile"
                              },
                              [_c("product-tile-skeleton")],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                ),
                _c(
                  "fade-transition",
                  { attrs: { duration: { enter: 600, leave: 200 } } },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              !this.fetchingStatus.status &&
                              this.currentTotal === 0,
                            expression:
                              "!this.fetchingStatus.status && this.currentTotal === 0"
                          }
                        ],
                        key: "noProducts",
                        staticClass: "collection-grid__no-results"
                      },
                      [
                        _c("h3", [_vm._v("Oh no!")]),
                        _c("p", [
                          _vm._v(
                            "We couldn't find any products using your currently selected filters."
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm.productDisplayedCount != _vm.currentTotal
                  ? _c(
                      "div",
                      { staticClass: "collection-grid__load-more-buttons" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "button button--primary",
                            on: { click: _vm.loadMore }
                          },
                          [_vm._v("LOAD MORE")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "button button--secondary",
                            on: { click: _vm.loadAll }
                          },
                          [_vm._v("VIEW ALL")]
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "collection-grid-footer",
                  { attrs: { id: "total-product-count" } },
                  [
                    _c("div", { staticClass: "body-md" }, [
                      _vm._v("Viewing "),
                      _c("span", { staticClass: "body-md bold" }, [
                        _vm._v(_vm._s(_vm.productDisplayedCount) + " ")
                      ]),
                      _c("span", { staticClass: "body-md" }, [_vm._v("of ")]),
                      _c("span", { staticClass: "body-md bold" }, [
                        _vm._v(_vm._s(_vm.currentTotal))
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }